/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileZipSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileZipSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M12.844 2h2.5v1.875h-2.5V2Zm0 3.75h-2.5V3.875h2.5V5.75Zm0 1.875V5.75h2.5v1.875h-2.5Zm0 1.875h-2.5V7.625h2.5V9.5Zm0 1.875h2.5V9.5h-2.5v1.875Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.844 11.375v1.875h2.811v2.627l.001.12c0 1.774-.819 2.566-2.655 2.566-1.837 0-2.656-.792-2.656-2.566v-.005h-.001v-4.617h2.5Zm.695 5.433a.937.937 0 1 1-1.042-1.558.937.937 0 0 1 1.042 1.558Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M15.344 2h-2.5v.5h2.5V2Zm-2.5 2.375v-.5h-2.5v.5h2.5Zm0 3.25h-2.5v.5h2.5v-.5Zm2.5-1.375v-.5h-2.5v.5h2.5Zm-2.5 3.25v.5h2.5v-.5h-2.5Zm0 2.375v-.5h-2.5v.5h2.5Zm2.811 4.242a5.957 5.957 0 0 0 0-.24v.24Zm0-2.367v-.5h-2.811v.5h2.811Zm-2.637 3.216a.937.937 0 0 0 .903-.687.948.948 0 0 1-.037.609.937.937 0 0 1-1.77-.609.937.937 0 0 0 .904.688Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileZipSmall
};
